/* SUNSYRA — mobile nav toggle
   defer ile yüklendiğinden DOM zaten hazır, DOMContentLoaded beklemeye gerek yok */
(() => {
  const menuBtn = document.querySelector('[data-st-menu]');
  if (!menuBtn) return;
  const navId = menuBtn.getAttribute('aria-controls');
  const mobileNav = navId
    ? document.getElementById(navId)
    : document.querySelector('.mobile-nav');
  if (!mobileNav) return;
  menuBtn.addEventListener('click', () => {
    const isOpen = !mobileNav.hasAttribute('hidden');
    if (isOpen) {
      mobileNav.setAttribute('hidden', '');
      menuBtn.setAttribute('aria-expanded', 'false');
    } else {
      mobileNav.removeAttribute('hidden');
      menuBtn.setAttribute('aria-expanded', 'true');
    }
  });
})();

(() => {
  const root = document.documentElement;
  root.classList.add('motion-enabled');
  const reveal = () => {
    const items = document.querySelectorAll('[data-motion-section] .motion-reveal');
    if (!('IntersectionObserver' in window)) { items.forEach((item) => item.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); instance.unobserve(entry.target); } });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  };
  reveal();
})();

/* eTOM / SUNSYRA storefront behavior */
(() => {
  const enhanceProductPage = () => {
    const pageWidth = document.querySelector('.template-product .section-padding .page-width');
    const galleryGrid = pageWidth?.querySelector(':scope > .grid.grid--2');
    const productInfo = pageWidth?.children?.[1];
    if (!galleryGrid || galleryGrid.dataset.sunsyraEnhanced === 'true') return;
    galleryGrid.dataset.sunsyraEnhanced = 'true';
    productInfo?.classList.add('sunsyra-product-info');
    const shell = document.createElement('div');
    shell.className = 'sunsyra-gallery-shell';
    galleryGrid.parentNode?.insertBefore(shell, galleryGrid);
    shell.appendChild(galleryGrid);
    const slides = Array.from(galleryGrid.querySelectorAll(':scope > .product-card__media'));
    if (!slides.length) return;
    slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === 0);
      const image = slide.querySelector('img');
      if (image) {
        image.loading = index === 0 ? 'eager' : 'lazy';
        if (!image.alt || /^[a-f0-9]{20,}$/i.test(image.alt)) image.alt = `SUNSYRA ürün görseli ${index + 1}`;
      }
    });
    let current = 0;
    const controls = document.createElement('div');
    controls.className = 'sunsyra-gallery-controls';
    const previous = document.createElement('button');
    previous.type = 'button'; previous.className = 'sunsyra-gallery-arrow'; previous.setAttribute('aria-label', 'Önceki ürün görseli'); previous.textContent = '‹';
    const count = document.createElement('span'); count.className = 'sunsyra-gallery-count';
    const next = document.createElement('button');
    next.type = 'button'; next.className = 'sunsyra-gallery-arrow'; next.setAttribute('aria-label', 'Sonraki ürün görseli'); next.textContent = '›';
    controls.append(previous, count, next);
    shell.appendChild(controls);
    const thumbs = document.createElement('div');
    thumbs.className = 'sunsyra-gallery-thumbs';
    const thumbButtons = slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'sunsyra-gallery-thumb'; button.setAttribute('aria-label', `Ürün görseli ${index + 1}`);
      const image = slide.querySelector('img');
      if (image) { const thumb = image.cloneNode(true); thumb.removeAttribute('srcset'); button.appendChild(thumb); }
      button.addEventListener('click', () => setSlide(index));
      thumbs.appendChild(button);
      return button;
    });
    shell.appendChild(thumbs);
    function setSlide(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      thumbButtons.forEach((button, i) => { button.classList.toggle('is-active', i === current); button.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      count.textContent = `${current + 1} / ${slides.length}`;
    }
    previous.addEventListener('click', () => setSlide(current - 1));
    next.addEventListener('click', () => setSlide(current + 1));
    let touchStartX = null;
    galleryGrid.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
    galleryGrid.addEventListener('touchend', event => {
      if (touchStartX === null) return;
      const delta = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(delta) > 40) setSlide(current + (delta < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });
    setSlide(0);
    const form = productInfo?.querySelector('form.shopify-product-form');
    const price = productInfo?.querySelector('h1')?.nextElementSibling;
    if (form && price) { form.classList.add('sunsyra-product-cta'); price.insertAdjacentElement('afterend', form); }
    productInfo?.querySelectorAll('img').forEach(image => { image.classList.add('sunsyra-embedded-media'); image.alt = ''; });
  };
  const enhanceCollectionsPage = () => {
    const list = document.querySelector('.template-list-collections #collections-listing ul');
    if (!list || list.dataset.sunsyraEnhanced === 'true') return;
    list.dataset.sunsyraEnhanced = 'true';
    Array.from(list.querySelectorAll(':scope > li')).forEach((card, index) => {
      card.classList.add('sunsyra-collection-card');
      const link = card.querySelector('a');
      const title = (link?.textContent || '').trim();
      const visual = document.createElement('span');
      visual.className = 'sunsyra-collection-card__visual';
      visual.setAttribute('aria-hidden', 'true');
      visual.textContent = title.slice(0, 1).toUpperCase() || String(index + 1);
      card.insertBefore(visual, card.firstChild);
      const hint = card.querySelector('.hint');
      if (hint) hint.textContent = 'Koleksiyonu keşfet';
      const arrow = document.createElement('span');
      arrow.className = 'sunsyra-collection-card__arrow'; arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '↗'; card.appendChild(arrow);
      const href = link?.getAttribute('href');
      if (!href) return;
      fetch(href, { headers: { Accept: 'text/html' } }).then(response => response.text()).then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const image = parsed.querySelector('img[src*="/cdn/shop/files/"]');
        if (image?.getAttribute('src')) visual.style.backgroundImage = `url("${image.getAttribute('src')}")`;
      }).catch(() => undefined);
    });
  };
  if (document.body.classList.contains('template-product')) enhanceProductPage();
  if (document.body.classList.contains('template-list-collections')) enhanceCollectionsPage();
})();

/* SUNSYRA — purchase-row thumbnail update on variant change */
(() => {
  const init = () => {
    const variantSelect = document.querySelector('[data-st-variant-select]');
    const dataEl = document.querySelector('[data-st-product-data]');
    if (!variantSelect || !dataEl) return;
    let variantData;
    try { variantData = JSON.parse(dataEl.textContent).variants; } catch (e) { return; }
    const updateThumbs = () => {
      const selectedId = Number(variantSelect.value);
      const variant = variantData?.find((v) => v.id === selectedId);
      if (!variant) return;
      const mediaId = variant.media;
      const slide = document.querySelector(`.gallery-stage [data-st-media="${mediaId}"] img`);
      if (!slide?.src) return;
      document.querySelectorAll('[data-st-purchase-thumb]').forEach((thumb) => {
        thumb.style.opacity = '0';
        thumb.onload = () => { thumb.style.opacity = '1'; };
        thumb.src = slide.src;
      });
    };
    variantSelect.addEventListener('change', updateThumbs);
    document.querySelectorAll('[data-st-option]').forEach((opt) => {
      opt.addEventListener('change', () => setTimeout(updateThumbs, 30));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
